import { TierType } from 'src/features/AccordionSelect/types';

export const colours = {
    blush: '#f094f1',
    lilac: '#c891ff',
    sapphire: '#8ea5ff',
    azure: '#5cc5ff',
    turquoise: '#34d7da',
    jade: '#5be7b6',
    teal: '#0b3239',
    grey: '#f8f8f8',
    white: '#ffffff',
};

export const getTitleIconAndColour = (sectionIndex: number | undefined, tier?: TierType) => {
    if (tier === 'question') {
        return { colourIcon: '', icon: '', colour: 'white', bgColour: 'bg-white' };
    }
    switch (sectionIndex) {
        case 0:
            return { colourIcon: '01', icon: '07', colour: 'blush', bgColour: 'bg-blush' };
        case 1:
            return { colourIcon: '02', icon: '08', colour: 'lilac', bgColour: 'bg-lilac' };
        case 2:
            return { colourIcon: '03', icon: '09', colour: 'sapphire', bgColour: 'bg-sapphire' };
        case 3:
            return { colourIcon: '04', icon: '10', colour: 'azure', bgColour: 'bg-azure' };
        case 4:
            return { colourIcon: '05', icon: '11', colour: 'turquoise', bgColour: 'bg-turquoise' };
        case 5:
            return { colourIcon: '06', icon: '12', colour: 'jade', bgColour: 'bg-jade' };
        default:
            return { colourIcon: '', icon: '', colour: 'grey', bgColour: 'bg-grey' }; // subsection
    }
};

export const getColourHexes = (tier: TierType, sectionIndex?: number) => {
    if (tier === 'section') {
        switch (sectionIndex) {
            case 0:
                return colours.blush;
            case 1:
                return colours.lilac;
            case 2:
                return colours.sapphire;
            case 3:
                return colours.azure;
            case 4:
                return colours.turquoise;
            case 5:
                return colours.jade;
        }
    }
    if (tier === 'subsection') {
        return colours.grey;
    }
    return colours.white;
};

export const headerClasses = (tier?: TierType) => {
    switch (tier) {
        case 'section':
        case 'subsection':
            return 'accordion-header col-12 p-0 border-b border-gray-300';
        default:
            return 'accordion-header col-12 p-0';
    }
};

export const colourClasses = (sectionIndex: number | undefined, tier: TierType) => {
    const bgColour = `${getTitleIconAndColour(sectionIndex).bgColour}`;
    switch (tier) {
        case 'section':
            return `rounded-sm my-3 p-2 w-full ${bgColour}`;
        case 'subsection':
            return `rounded-sm my-2 py-3 pl-10 pr-2 w-full ${bgColour}`;
        case 'question':
            return 'py-2 pl-18 pr-2 w-full';
        default:
            return '';
    }
};
